/** Gợi ý phương diện BSC (A–D) từ câu trả lời bubble B4. */
export type B4AspectKey = 'A' | 'B' | 'C' | 'D';

const fold = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .toLowerCase();

export function detectB4AspectFromText(text: string): B4AspectKey | null {
  const q = fold(text);
  if (/tai chinh|financial|doanh thu|loi nhuan/.test(q)) return 'A';
  if (/khach hang|customer|thị truong|thit truong/.test(q)) return 'B';
  if (/quy trinh|noi bo|internal|van hanh|san xuat/.test(q)) return 'C';
  if (/hoc hoi|dao tao|learning|nhan su|phat trien|van hoa/.test(q)) return 'D';
  return null;
}

export function objectiveHtmlFromPlain(text: string): string {
  const safe = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
  return `<p>${safe}</p>`;
}

/** Mặc định xoay D→C→B→A (nhân quả từ Học hỏi lên). */
export function defaultAspectForIndex(index: number): B4AspectKey {
  const cycle: B4AspectKey[] = ['D', 'C', 'B', 'A'];
  return cycle[index % cycle.length];
}
